<!-- ═══════════════════════════════════════════
     V3 DESIGN — Job Invites
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">
  <!-- AUDIT_04 CG7 — re-add "All Filters" trigger dropped from V3.
       Wires to existing openFilterSlider() + jobInvitesStatusList
       count (same pattern as job-applicants V3 filter button). -->
  <div class="jc-v3-tab-toolbar jc-v3-tab-toolbar-end">
    <div id="candidate_job_invite_filter" class="jc-v3-icon-btn jc-v3-filter-labeled"
         (click)="openFilterSlider()" title="All Filters">
      <span class="jc-v3-filter-label">All Filters</span>
      <span *ngIf="jobInvitesStatusList?.length > 0" class="filter-count">{{ jobInvitesStatusList.length }}</span>
      <ng-icon name="tablerFilter"></ng-icon>
    </div>
  </div>
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires. -->
  <div infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="200"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()">
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length === 0" [countforView]="5"
      [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    <ng-container *ngIf="viewedList?.length > 0; else noResultV3">
      <div *ngFor="let item of viewedList; let i = index">
        <app-job-card [viewSize]="'jc-v3-row'" [indexInput]="i" [showCheckBox]="'false'" (jobemit)="getjobId($event)"
          [filterApplicantData]="filterApplicantData" (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"
          [showStatus]="true" [JobData]="item.jobDetails" [From]="'JOBS_FROM_PLATFORM'" [pageFrom]="'jobsInvited'"
          [JobDataUser]="item.user" [candidateData]="item.candidateEntity"
          [currentCandidateId]="candidateDetails?.candidateId"></app-job-card>
      </div>
      <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length > 0" [countforView]="2"
        [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      <div *ngIf="stopscrollFlag && viewedList?.length > 0" class="jc-v3-list-done">
        <ng-icon name="tablerCircleCheck"></ng-icon>
        <p>You've reached the bottom of the page</p>
      </div>
    </ng-container>
    <ng-template #noResultV3>
      <div *ngIf="!loadAPIcall" class="jc-v3-empty-state">
        <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
          <rect x="55" y="55" width="90" height="60" rx="8" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
          <rect x="65" y="68" width="40" height="4" rx="2" fill="#DDD6FE"/>
          <rect x="65" y="77" width="55" height="4" rx="2" fill="#EDE9FE"/>
          <rect x="65" y="86" width="48" height="4" rx="2" fill="#EDE9FE"/>
          <circle cx="148" cy="128" r="16" fill="#7C3AED" opacity="0.10"/>
          <circle cx="148" cy="128" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
          <path d="M144 128 l3 3 5-5" stroke="#7C3AED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
          <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
        </svg>
        <h3>No Job Invites Yet</h3>
        <p>Jobs you've been invited to will appear here.</p>
      </div>
    </ng-template>
    <div #scrollSentinel style="height:1px;"></div>
  </div>
</ng-container>

<!-- ═══════════════════════════════════════════
     V2 DESIGN (existing)
     ═══════════════════════════════════════════ -->
<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="200"
  [scrollWindow]="false" [alwaysCallback]="true" (scrolled)="onScrollDown()" id="entity-container">
  <div class="hpanel">
    <div class="panel-body pad-10">
      <div class="row">
        <div class="col-sm-8">
          <!-- <div class="filters">
            <div class="filters-list" (click)="removeEntity(item.itemId, i)"
              *ngFor="let item of jobInvitesStatusList; let i=index;">
              <span *ngIf="item == 'INITIATED' " class="filter-list-item"><span><i [ngClass]="colorLists[i]"></i></span>
                Invited</span>
              <span *ngIf="item == 'REJECTED'" class="filter-list-item"><span><i [ngClass]="colorLists[i]"></i></span>
                Rejected</span>
              <span *ngIf="item == 'ACCEPTED'" class="filter-list-item"><span><i [ngClass]="colorLists[i]"></i></span>
                Submitted</span>
              <span *ngIf="item != 'ACCEPTED' && item != 'REJECTED'&& item != 'INITIATED'"
                class="filter-list-item"><span><i [ngClass]="colorLists[i]"></i></span>
                {{item.value | titlecase}}</span>
              <span class="filter-tag-close-icon-style">
                <ng-icon name="tablerX"></ng-icon>
              </span>
            </div>
          </div> -->
        </div>
        <div class="col-sm-4 all-filters-container">
          <div id="candidate_job_invite_filter" class="all-filters-small" (click)="openFilterSlider()">
            <span>
              All Filters
            </span>
            <span *ngIf="jobInvitesStatusList?.length>0" class="counter">
              {{jobInvitesStatusList?.length}}
            </span>
            <ng-icon name="tablerFilter"></ng-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length==0" [countforView]="10" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>


  <ng-container *ngIf="viewedList?.length > 0; else noResult">
    <div *ngFor="let item of viewedList">
      <app-job-card [viewSize]="'medium'" [showCheckBox]="'false'" (jobemit)="getjobId($event)" [filterApplicantData]="filterApplicantData"
        (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)" [showStatus]="true" [JobData]="item.jobDetails" [From]="'JOBS_FROM_PLATFORM'" [pageFrom]="'jobsInvited'"
        [JobDataUser]="item.user" [candidateData]="item.candidateEntity" [currentCandidateId]="candidateDetails?.candidateId"></app-job-card>

      <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length>0" [countforView]="7" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

    </div>
    <div *ngIf="stopscrollFlag  && viewedList.length > 0" class="caught_up">
      <div class="col-md-12">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
      </div>
      <div class="col-md-12">
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </div>
  </ng-container>



  <ng-template #noResult>
    <div class="wert">
      <div class="col-md-12 mg-bt-9">
        <ng-icon name="tablerZoomQuestion" *ngIf="responseReceived"></ng-icon>
        <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon>
      </div>
      <div class="col-md-12 fig">{{jobInvitedFoundStatus}} </div>
    </div>
  </ng-template>
</div>
</ng-container>
